<template>
  <g>
    <path
      d="M22.9754 27.1075H8.25964C7.24793 27.1075 6.42017 26.2798 6.42017 25.2681V12.3182C6.42017 11.8123 6.83405 11.3984 7.3399 11.3984C7.84576 11.3984 8.25964 11.8123 8.25964 12.3182V25.2681H22.9754V12.3182C22.9754 11.8123 23.3893 11.3984 23.8952 11.3984C24.401 11.3984 24.8149 11.8123 24.8149 12.3182V25.2681C24.8149 26.2798 23.9963 27.1075 22.9754 27.1075Z"
      :fill="iconColor"
    />
    <path
      d="M6.87963 15.5326H4.12042C3.61457 15.5326 3.20068 15.1187 3.20068 14.6129C3.20068 14.107 3.61457 13.6931 4.12042 13.6931H6.87963C7.38549 13.6931 7.79937 14.107 7.79937 14.6129C7.79937 15.1187 7.39469 15.5326 6.87963 15.5326Z"
      :fill="iconColor"
    />
    <path
      d="M27.1138 15.5328H24.3546C23.8487 15.5328 23.4348 15.119 23.4348 14.6131C23.4348 14.1072 23.8487 13.6934 24.3546 13.6934H27.1138C27.6196 13.6934 28.0335 14.1072 28.0335 14.6131C28.0335 15.119 27.6288 15.5328 27.1138 15.5328Z"
      :fill="iconColor"
    />
    <path
      d="M24.8956 13.0018H6.34454C5.83869 13.0018 5.4248 12.5879 5.4248 12.0821C5.4248 11.5762 5.83869 11.1624 6.34454 11.1624H24.8956C25.4015 11.1624 25.8154 11.5762 25.8154 12.0821C25.8154 12.5879 25.4015 13.0018 24.8956 13.0018Z"
      :fill="iconColor"
    />
    <path
      d="M24.042 12.8508C23.7937 12.8508 23.5454 12.7497 23.3706 12.5565C21.476 10.5055 18.6524 9.32824 15.6264 9.32824C12.6005 9.32824 9.77689 10.5055 7.88223 12.5565C7.53273 12.9336 6.95332 12.952 6.58542 12.6117C6.20833 12.2622 6.18991 11.6828 6.53021 11.3149C8.77437 8.88677 12.0854 7.48877 15.6264 7.48877C19.1674 7.48877 22.4877 8.87757 24.7226 11.3149C25.0629 11.692 25.0445 12.2714 24.6674 12.6117C24.4927 12.7681 24.2628 12.8508 24.042 12.8508Z"
      :fill="iconColor"
    />
    <path
      d="M15.6164 5.33472C14.7242 5.33472 14.0068 6.05211 14.0068 6.94426C14.0068 7.8364 14.7242 8.5538 15.6164 8.5538C16.5085 8.5538 17.2259 7.8364 17.2259 6.94426C17.2259 6.06131 16.5085 5.33472 15.6164 5.33472Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
